<template>
  <div v-if="initialized">
    <div id="app">
      <router-view></router-view>
    </div>

    <b-modal centered v-model="alertshown" class="alertbox" ref="modalalert" id="modalalert" v-bind:hide-footer="true" v-bind:hide-header="true">
      <div class="row">
        <div class="col-12 center mb-4">
          <p><strong>{{modaltext}}</strong></p>
        </div>
      </div> 
      <div class="row">
        <div class="col-6 center">
          <a href="#" v-on:click="alertshown = false" class="btn button-cancel">{{$t('NO')}}</a>
        </div>
        <div class="col-6 center">
          <a href="#" class="btn button-primary" v-on:click="positiveModalFunc">{{$t('YES')}}</a>
        </div>
      </div>
    </b-modal>

  </div>
  <div v-else-if="!initialized" class="loading-page">
    <icon icon="spinner" scale="2" spin></icon>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import globals from '@/api/Globals'

export default {
  name: 'app',
  data: function()
  {
    return {alertshown: false, positivefunc: function(){}, modaltext: ''}
  },
  components:
  {

  },
  methods:
  {
    ...mapActions([
      'getGlobals',
      'fetchLanguage',
    ]),
    positiveModalFunc: function()
    {
      var me = this;
      me.positivefunc();
      me.alertshown = false;
      me.positivefunc = function(){};
    }
  },
  created: function()
  {
    this.getGlobals();
  },
  watch:
  {
    'globals.groupId': function(value)
    {
      if(value != 0 && value != 2)
      {
        if (this.globals.acl.ChildKindergarten && this.globals.acl.ChildKindergarten.instantiate)
        {
          this.$router.push('/admin/dashboardkindergarten')
        }
        else
        {
          this.$router.push('/admin/dashboard')
        }
        
      }
      else
      {
        this.$router.push('/admin/')
      }
    },
    'globals.langId': function(value)
    {
      this.fetchLanguage(value);
    },
    translation: function(value)
    {
      this.$i18n.setLocaleMessage('ln'+value.key, value.root)
      this.$i18n.locale = 'ln'+value.key
    },
    langInitialized: function(value)
    {
      if(value)
      {
        this.$i18n.missing = function(handler, key, vueInst)
        {
          globals.checkTrans(key)
        }
      }
    },
    modalAlert: function(val)
    {
      var me = this;
      me.alertshown = true;
      me.modaltext = val.text;
      me.positivefunc = val.btnAction;
    }
  },
  computed:
  {
    ...mapGetters([
      'globals',
      'modalAlert',
      'translation',
      'langInitialized'
    ]),
    loggedIn: function()
    {
      return (this.globals.groupId != 2) ? true : false;
    },
    initialized: function()
    {
      return (this.globals.groupId != 0) ? true : false;
    }
  }
}
</script>